<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Unvergessliche Momente mit unserer Fotobox'
  },
  subtitle: {
    type: String,
    default: 'Sehen Sie sich an, wie unsere Fotoboxen für Begeisterung sorgen.'
  },
  images: {
    type: Array,
    default: () => Array.from({ length: 6 }, (_, i) => `https://www.mietfotobox.com/static/assets/sample-${i + 1}.webp`)
  },
  locationName: {
    type: String,
    default: ''
  }
})

// Wenn ein Standortname übergeben wurde, füge ihn zum Titel hinzu
const displayTitle = computed(() => {
  if (props.locationName) {
    return `Unvergessliche Momente mit unserer Fotobox in ${props.locationName}`
  }
  return props.title
})
</script>

<template>
  <section class="py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="heading-2 mb-4">{{ displayTitle }}</h2>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto">{{ subtitle }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <!-- Bilder -->
        <div v-for="(image, i) in images" :key="i" class="aspect-square bg-gray-200 rounded-lg overflow-hidden">
          <div class="w-full h-full bg-cover bg-center" :style="`background-image: url('${image}');`" />
        </div>
      </div>
    </div>
  </section>
</template>